var _defs, _rect, _g, _text, _text2, _text3, _rect2, _g2, _g3, _text4, _text5, _rect3, _text6, _text7, _path, _text8, _text9, _g4, _g5, _g6, _rect4, _circle, _path2, _text0, _text1, _text10, _text11, _g7, _rect5, _text12, _g8, _text13, _rect6, _text14, _text15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContextSwitchingTaxMath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    width: 1200,
    height: 700,
    role: "img",
    "aria-label": "Diagram comparing a human-routed workday fragmented by app switching with an agent-routed workday where BossDrop batches coordination into a single reviewed queue",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mAi",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#b7a4e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mRed",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb7185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f97316"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mGold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe9a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6cf6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2b24a"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .h  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 800; fill: #f4f0fc; }\n      .s  { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 600; fill: #b8b2cc; }\n      .lab { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #e2d9f5; }\n      .tiny { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #aaa4bd; letter-spacing: 2px; }\n      .eyebrow { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; font-weight: 700; fill: #cfc3ee; letter-spacing: 4px; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "url(#mBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 100 H1200 M0 200 H1200 M0 300 H1200 M0 400 H1200 M0 500 H1200 M0 600 H1200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 0 V700 M400 0 V700 M600 0 V700 M800 0 V700 M1000 0 V700"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 62,
    className: "eyebrow",
    fontSize: 18
  }, "THE SHAPE OF A WORKDAY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 118,
    className: "h",
    fontSize: 28
  }, "Human-routed coordination")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 148,
    className: "s",
    fontSize: 18
  }, "Every signal arrives on its own schedule. The person is the router.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 176,
    width: 1080,
    height: 62,
    rx: 14,
    fill: "#1d1a2e"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#mRed)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 188,
    width: 34,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 188,
    width: 14,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 188,
    width: 46,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 188,
    width: 12,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 188,
    width: 28,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 188,
    width: 14,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 188,
    width: 52,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 188,
    width: 13,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 188,
    width: 30,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439,
    y: 188,
    width: 12,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 188,
    width: 44,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 188,
    width: 14,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 188,
    width: 26,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 188,
    width: 12,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617,
    y: 188,
    width: 48,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679,
    y: 188,
    width: 13,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 188,
    width: 32,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 752,
    y: 188,
    width: 12,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778,
    y: 188,
    width: 40,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 188,
    width: 14,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 860,
    y: 188,
    width: 28,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 902,
    y: 188,
    width: 12,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928,
    y: 188,
    width: 50,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 992,
    y: 188,
    width: 13,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1019,
    y: 188,
    width: 34,
    height: 38,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067,
    y: 188,
    width: 12,
    height: 38,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093,
    y: 188,
    width: 37,
    height: 38,
    rx: 6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fbbf24",
    strokeWidth: 2.5,
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 168 V178 M206 168 V178 M274 168 V178 M368 168 V178 M439 168 V178 M523 168 V178 M591 168 V178 M679 168 V178 M752 168 V178 M832 168 V178 M902 168 V178 M992 168 V178 M1067 168 V178"
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 164,
    className: "tiny",
    fontSize: 13
  }, "INTERRUPTIONS")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 266,
    className: "s",
    fontSize: 17
  }, "Longest unbroken block:")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 248,
    width: 66,
    height: 26,
    rx: 8,
    fill: "#2a1622",
    stroke: "url(#mRed)",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 281,
    y: 267,
    className: "lab",
    fontSize: 15,
    textAnchor: "middle"
  }, "~12 min")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 336,
    y: 266,
    className: "s",
    fontSize: 17
  }, "Re-orientation time is charged on every switch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 316 H1140",
    stroke: "#2a2547",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 374,
    className: "h",
    fontSize: 28
  }, "Agent-routed coordination")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 404,
    className: "s",
    fontSize: 18
  }, "BossDrop absorbs the signals, batches them, and surfaces one reviewed queue.")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#1d1a2e",
    stroke: "#342e57",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 430,
    width: 120,
    height: 46,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 486,
    width: 120,
    height: 46,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 542,
    width: 120,
    height: 46,
    rx: 12
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "lab",
    fontSize: 15,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 459
  }, "Chat pings"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 515
  }, "Task churn"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 571
  }, "Approvals"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#mAi)",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 453 C 240 453, 250 500, 300 509"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 509 H300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 565 C 240 565, 250 518, 300 509"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 440,
    width: 300,
    height: 140,
    rx: 20,
    fill: "#171523",
    stroke: "url(#mAi)",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 348,
    cy: 478,
    r: 18,
    fill: "url(#mGold)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M341 478 l5 6 l11 -13",
    stroke: "#121020",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 484,
    className: "h",
    fontSize: 20
  }, "Detect \u2192 decide")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 522,
    className: "s",
    fontSize: 16
  }, "Gather context across tools")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 546,
    className: "s",
    fontSize: 16
  }, "Act where it is allowed")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 324,
    y: 570,
    className: "s",
    fontSize: 16
  }, "Escalate only what needs you")), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#mAi)",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 510 H660"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 501 L662 510 L650 519"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 440,
    width: 470,
    height: 140,
    rx: 20,
    fill: "#171523",
    stroke: "#342e57",
    strokeWidth: 2
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 480,
    className: "h",
    fontSize: 20
  }, "One review block")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#mAi)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 500,
    width: 120,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 500,
    width: 88,
    height: 20,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 932,
    y: 500,
    width: 178,
    height: 20,
    rx: 6
  }))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 700,
    y: 552,
    className: "s",
    fontSize: 16
  }, "Three decisions, batched. The rest already handled and logged.")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 618,
    width: 1080,
    height: 52,
    rx: 14,
    fill: "#171523",
    stroke: "#342e57",
    strokeWidth: 2
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 650,
    className: "lab",
    fontSize: 17
  }, "Switches removed \xD7 re-orientation cost per switch = hours returned to the work you actually hired for.")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1114,
    y: 650,
    className: "tiny",
    fontSize: 13,
    textAnchor: "end"
  }, "BOSSDROP.AI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextSwitchingTaxMath);
export default __webpack_public_path__ + "static/media/context-switching-tax-math.187eabfe42bb1042da97f256cdfbe5d8.svg";
export { ForwardRef as ReactComponent };